import React, { useEffect, useRef } from 'react';
import { AppState } from 'core/redux/reducers';
// import { hot } from 'react-hot-loader/root'
import { useSelector } from 'react-redux';
import Step1 from './Step1';
import {
  BOOKING_STEP1,
  BOOKING_STEP2,
  BOOKING_STEP3,
  BOOKING_STEP4,
} from 'core/redux/features/booking/constants';

import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import qsa from 'dom-helpers/querySelectorAll';
import { ownerDocument } from 'dom-helpers';
import { selectActiveProduct } from 'core/redux/features/products/reducers/products';
import { useFBQFBQAddToCartEffect } from '../../Shared/hooks';
import { FBQPageView } from '../../../utils/fbPixel';
import { GAPageView } from 'utils/googleAnalytics';

interface OwnProps {
  onHideMenuModal: () => void;
}

type TProps = OwnProps;

function StepsComponent(props: TProps) {
  const activeStepIndex = useSelector(
    (state: AppState) => state.booking.activeStepIndex,
  );
  const product = useSelector(selectActiveProduct);
  const bookingOrder = useSelector((state: AppState) => state.booking.order);
  const docRef = useRef(null);
  useEffect(() => {
    if (!docRef.current) {
      return;
    }
    const doc = ownerDocument();
    const $el = qsa(doc, `#step${activeStepIndex + 1} .pop-page-outer`);
    if ($el.length === 0) {
      return;
    }

    // const findParent = closest($el[0], '.pop-page-outer');
    if ($el[0]) {
      setTimeout(() => {
        $el[0].scroll(0, 0);
      }, 300);
    }
  }, [activeStepIndex]);

  useEffect(() => {
    FBQPageView();
    GAPageView();
  }, [activeStepIndex]);

  useFBQFBQAddToCartEffect({
    shouldTrack: activeStepIndex === BOOKING_STEP2,
    total: bookingOrder.total,
    product,
  });

  return (
    <div className="section section-box section-product-list section-product-page">
      <div
        ref={docRef}
        id="step1"
        style={{
          display: activeStepIndex !== BOOKING_STEP1 ? 'none' : '',
        }}
      >
        <Step1 onHideMenuModal={props.onHideMenuModal} />
      </div>
      <div
        id="step2"
        style={{
          display: activeStepIndex !== BOOKING_STEP2 ? 'none' : '',
        }}
      >
        <Step2 />
      </div>
      <div
        id="step3"
        style={{
          display: activeStepIndex !== BOOKING_STEP3 ? 'none' : '',
        }}
      >
        <Step3 />
      </div>
      <div
        id="step4"
        style={{
          display: activeStepIndex !== BOOKING_STEP4 ? 'none' : '',
        }}
      >
        <Step4 />
      </div>
    </div>
  );
}

// const Steps =
//   process.env.NODE_ENV !== 'production' ? hot(StepsComponent) : StepsComponent;
export default StepsComponent;
